import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Stack,
  IconButton,
  Divider,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { company, gradientColor } from "./constants";

const Footer = () => {
  const footerStyle = {
    background: gradientColor,
    color: "white",
    py: 6,
    mt: "auto",
    boxShadow: "0 -4px 20px rgba(0,0,0,0.1)",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "4px",
      background: "rgba(255,255,255,0.1)",
    },
  };

  const sectionTitleStyle = {
    mb: 3,
    fontWeight: 700,
    fontSize: "1.25rem",
    position: "relative",
    display: "inline-block",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -8,
      left: 0,
      width: "40px",
      height: "3px",
      backgroundColor: "rgba(255,255,255,0.4)",
    },
  };

  const contactItemStyle = {
    display: "flex",
    alignItems: "center",
    transition: "transform 0.2s",
    "&:hover": {
      transform: "translateX(8px)",
    },
  };

  const iconStyle = {
    marginRight: 2,
    fontSize: "1.4rem",
    backgroundColor: "rgba(255,255,255,0.1)",
    padding: 1,
    borderRadius: "50%",
  };

  const socialIconStyle = {
    color: "white",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.2)",
    },
  };

  return (
    <Box sx={footerStyle} id="contact">
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={sectionTitleStyle}>
              {company.name}
            </Typography>
            <Typography
              variant="body2"
              sx={{ mt: 3, lineHeight: 1.8, opacity: 0.9 }}
            >
              Bestech Enterprises, established in 2000, specializes in
              innovative healthcare solutions, providing reliable medical
              equipment to hospitals nationwide.
            </Typography>
            <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
              <IconButton size="small" sx={socialIconStyle}>
                <FacebookIcon />
              </IconButton>
              <IconButton size="small" sx={socialIconStyle}>
                <TwitterIcon />
              </IconButton>
              <IconButton size="small" sx={socialIconStyle}>
                <LinkedInIcon />
              </IconButton>
              <IconButton size="small" sx={socialIconStyle}>
                <InstagramIcon />
              </IconButton>
            </Stack>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={sectionTitleStyle}>
              Our Locations
            </Typography>
            <Stack spacing={3} sx={{ mt: 3 }}>
              <Box sx={contactItemStyle}>
                <LocationOnIcon sx={iconStyle} />
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  {company.address1}
                </Typography>
              </Box>
              <Box sx={contactItemStyle}>
                <LocationOnIcon sx={iconStyle} />
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  {company.address2}
                </Typography>
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={sectionTitleStyle}>
              Contact Info
            </Typography>
            <Stack spacing={3} sx={{ mt: 3 }}>
              <Box sx={contactItemStyle}>
                <PhoneIcon sx={iconStyle} />
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  {company.number}
                </Typography>
              </Box>
              <Box sx={contactItemStyle}>
                <EmailIcon sx={iconStyle} />
                <Box>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    {company.email1}
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    {company.email2}
                  </Typography>
                </Box>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Divider
          sx={{ mt: 6, mb: 4, backgroundColor: "rgba(255,255,255,0.1)" }}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
